/**
 * Inline link that opens the inherent risk methodology from inside the topic risk drawer — the same
 * explanation the risk screening configuration page shows, rather than the overall risk methodology.
 */
import { useDialogState } from '@app/src/hooks/mui-hooks'
import RiskScreeningInfoDialog from '@app/src/pages/Configurations/ConfigurationsPages/RiskScreening/RiskScreeningInfoDialog'
import { Link } from '@mui/material'
import React from 'react'

export const InherentRiskMethodologyLink: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [isDialogOpen, openDialog, closeDialog] = useDialogState()

  return (
    <>
      <Link component="button" type="button" color="inherit" onClick={openDialog}>
        {children}
      </Link>
      <RiskScreeningInfoDialog open={isDialogOpen} closeDialog={closeDialog} />
    </>
  )
}

export default InherentRiskMethodologyLink
